import React, { forwardRef } from 'react';
import { Search, X } from 'lucide-react';

export const SearchInput = forwardRef(function SearchInput(
  { value, onChange, onFocus, onBlur, placeholder, onClear, showShortcut = true },
  ref,
) {
  const hasValue = !!String(value || '').trim();
  return (
    <div className="kp-search-input-wrap">
      <Search className="kp-search-input-icon" size={14} strokeWidth={2.5} aria-hidden="true" />
      <input
        ref={ref}
        type="search"
        className="kp-search-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        aria-label="Sök i KanPlan"
        autoComplete="off"
        spellCheck={false}
      />
      {hasValue ? (
        <button
          type="button"
          className="kp-search-input-clear"
          onClick={onClear}
          aria-label="Rensa sökning"
        >
          <X size={13} strokeWidth={2.5} aria-hidden="true" />
        </button>
      ) : showShortcut ? (
        <span className="kp-search-input-kbd" aria-hidden="true">⌘K</span>
      ) : null}
    </div>
  );
});
